import { useEffect, useState } from "react";
import BigNumber from 'bignumber.js';

import * as S from './styles';

import Separator from '../../Separator';
import { useGlobal } from '../../../contexts/globalContext';
import Alert from '@material-ui/lab/Alert';
import { getSessionStorage } from '../../../utils/getSessionStorage';

const EntertainmentSideSummary = ({
	userPoints,
	cashPrice,
	pointsPrice,
	setPointsPrice,
	minimumPointsToBuy,
	paymentInPoints,
	paymentInMoney,
	pointsTotalValue,
	cashTotalValue,
	discountPoints,
	discountCash,
	campaignDiscountPoints,
	campaignDiscountCash,
	discountPercentage,
}) => {
	const { signed, user } = useGlobal();
	const [coinAlias, setCoinAlias] = useState('Pontos');
	const [shortenCoinAlias, setShortenCoinAlias] = useState('Pts');

	const selectedActivity = getSessionStorage('@EntertainmentSelected');

	useEffect(() => {
		setCoinAlias(user?.campaign?.campaignConfig?.coinAlias || 'Pontos');
		setPointsPrice(
			new BigNumber(selectedActivity?.data?.totalPrice)
				.integerValue(BigNumber.ROUND_HALF_DOWN)
				.toNumber()
		);
		setShortenCoinAlias(
			user?.campaign?.campaignConfig?.shortenCoinAlias || 'Pts'
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		selectedActivity,
		user?.campaign?.campaignConfig?.coinAlias,
		user?.campaign?.campaignConfig?.shortenCoinAlias,
	]);

	const Header = ({ type, date, ...props }) => {
		return (
			<S.SideHeader {...props}>
				<div>
					<span>{type}</span>
				</div>
				<span className='date-header'>
					{date !== undefined && date !== 'Invalid Date' && date}
				</span>
			</S.SideHeader>
		);
	};

	const SubHeader = ({ type, hour, ...props }) => {
		return (
			<S.SideHeader {...props}>
				<div>
					<span>{type}</span>
				</div>
				<span className='date-header'>
					{hour !== undefined && hour !== 'Invalid Hour' && hour}
				</span>
			</S.SideHeader>
		);
	};

	return (
		<div>
			<Header
				className='first'
				type='ENTRADA'
				date={selectedActivity?.data.serviceDate}
			/>
			<S.BlankCardOnly></S.BlankCardOnly>
			{selectedActivity?.data?.startingTimes &&
			selectedActivity.data.startingTimes.length > 0 ? (
				<SubHeader type='HORÁRIO' hour={selectedActivity.data.selectedTime} />
			) : null}
			{selectedActivity?.data?.returnDate &&
			selectedActivity.data.returnDate !== undefined ? (
				<Header type='RETORNO' date={selectedActivity?.data.returnDate} />
			) : null}
			<Separator className='solid' />
			<S.BlankCardOnly>
				<S.PagamentoLabel>Pagamento</S.PagamentoLabel>
				<Separator className='solid thin' margin={15} />
				<S.BlankCardOnly>
					<S.QuarterSpacer></S.QuarterSpacer>
					<S.Total>
						<span className='semibold total'>Valor a ser pago</span>
						<span className='semibold total'>
							{'R$ '}
							{new Intl.NumberFormat('pt-BR', {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2,
							}).format(cashPrice)}
						</span>
					</S.Total>
					<S.QuarterSpacer></S.QuarterSpacer>
					<Separator className='solid thin' margin={15} />
					<S.QuarterSpacer></S.QuarterSpacer>
					{paymentInPoints > 0 && (
						<S.Total>
							<span className='semibold total'>Subtotal em {coinAlias}</span>
							<span className='semibold total'>{pointsTotalValue}</span>
						</S.Total>
					)}
					<S.Total>
						<span className='semibold total'>Subtotal em R$</span>
						<span className='semibold total'>
							{new Intl.NumberFormat('pt-BR', {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2,
							}).format(cashTotalValue)}
						</span>
					</S.Total>
					<S.QuarterSpacer></S.QuarterSpacer>
					{(discountPercentage > 0 ||
						discountPoints + campaignDiscountPoints > 0 ||
						discountCash + campaignDiscountCash > 0) && (
						<>
							<Separator className='solid thin' margin={15} />
							<S.QuarterSpacer></S.QuarterSpacer>
						</>
					)}

					{discountPercentage > 0 && (
						<S.Total>
							<span className='semibold total'>Desconto aplicado</span>
							<span className='semibold total'>-{discountPercentage}%</span>
						</S.Total>
					)}

					{discountPoints + campaignDiscountPoints > 0 && (
						<S.Total>
							<span className='semibold total'>Desconto aplicado em {coinAlias}</span>
							<span className='semibold total'>
								-{shortenCoinAlias} {discountPoints + campaignDiscountPoints}
							</span>
						</S.Total>
					)}
					{discountCash + campaignDiscountCash > 0 && (
						<S.Total>
							<span className='semibold total'>Desconto aplicado em R$</span>
							<span className='semibold total'>
								-
								{new Intl.NumberFormat('pt-BR', {
									minimumFractionDigits: 2,
									maximumFractionDigits: 2,
								}).format(discountCash + campaignDiscountCash)}
							</span>
						</S.Total>
					)}

					{(discountPercentage > 0 ||
						discountPoints + campaignDiscountPoints > 0 ||
						discountCash + campaignDiscountCash > 0) && (
						<S.QuarterSpacer></S.QuarterSpacer>
					)}

					<Separator className='solid thin' margin={15} />
					<S.QuarterSpacer></S.QuarterSpacer>
					{paymentInPoints > 0 && (
						<S.Total>
							<span className='bold total'>Total em {coinAlias}</span>
							<span className='bold total'>{paymentInPoints}</span>
						</S.Total>
					)}
					{user?.campaign?.acceptCashPayment && (
						<S.Total>
							<span className='bold total'>Total em R$</span>
							<span className='bold total'>
								{new Intl.NumberFormat('pt-BR', {
									minimumFractionDigits: 2,
									maximumFractionDigits: 2,
								}).format(paymentInMoney)}
							</span>
						</S.Total>
					)}
					<S.QuarterSpacer></S.QuarterSpacer>
				</S.BlankCardOnly>
				{signed && userPoints < minimumPointsToBuy && (
					<S.AlertStyle>
						<Alert variant='filled' severity='warning'>
							<span className='text'>
								Você deve possuir ao menos <br />
								<span className='value'>
									{minimumPointsToBuy} {coinAlias}
								</span>{' '}
								para realizar esta compra!
							</span>
						</Alert>
					</S.AlertStyle>
				)}
			</S.BlankCardOnly>
		</div>
	);
};

export default EntertainmentSideSummary;
